import {
  API_ENDPOINT,
  useClientApiV1MarketingPartnerLinksCreateMutation,
} from '../../resources/@types/courseSchema';

interface UseClientV1MarketingPartnerLinksMutation {
  options?: Parameters<typeof useClientApiV1MarketingPartnerLinksCreateMutation>[0]['options'];
}

export function useMarketingPartnerLinksCreateMutation({
  options,
}: UseClientV1MarketingPartnerLinksMutation) {
  return useClientApiV1MarketingPartnerLinksCreateMutation({
    url: API_ENDPOINT.CLIENT_V1_MARKETING_PARTNER_LINKS,
    options,
  });
}
